module.exports = __webpack_public_path__ + "img/badge_color_cap-academicplan.8c512dde.svg";